import { Dispatch, createContext } from "react";
import { State, Action } from "./types";
import { reducer } from "./reducer";
import {
  createStateHook,
  createDispatchHook,
  createContextHook,
  createProvider,
} from "../../factory";
import { getPersisted } from "../../../utils/storage";
import { COMFORT_PERSIST_KEY } from "./constants";
import { TIMEFRAME_PERSIST_PROP, COMPARETO_PERSIST_PROP } from "../constants";
import { TimeFrame, CompareTo } from "../types";
import { getTimeFrameCompareRanges } from "../../../components/Reports/Comfort/utils";

const persistedTimeFrame = getPersisted(
  { prop: TIMEFRAME_PERSIST_PROP, key: COMFORT_PERSIST_KEY },
  TimeFrame.Last3Months
);
const persistedCompareTo = getPersisted(
  { prop: COMPARETO_PERSIST_PROP, key: COMFORT_PERSIST_KEY },
  CompareTo.SamePeriodLastYear
);

const { timeFrameOption, compareToOption, current, compare } =
  getTimeFrameCompareRanges(persistedTimeFrame, persistedCompareTo);

export const initialState: State = {
  portfolioLoading: false,
  portfolioLoaded: false,
  portfolioError: false,
  portfolio: undefined,
  zonesLoading: false,
  zonesLoaded: false,
  zonesError: false,
  zones: undefined,
  viewBy: "hoursDiscomfort",
  rankDir: "worst",
  timeFrameOption,
  compareToOption,
  current,
  compare,
};

const stateContext = createContext<State | undefined>(undefined);
const dispatchContext = createContext<Dispatch<Action> | undefined>(undefined);

export const ComfortProvider = createProvider(
  stateContext,
  dispatchContext,
  reducer,
  initialState
);
export const useState = createStateHook(stateContext);
export const useDispatch = createDispatchHook(dispatchContext);
export const useWorkflow = createContextHook(stateContext, dispatchContext);
